import React from 'react';
import {
  Box,
  Text,
  Button,
  useDisclosure,
  HStack,
} from '@chakra-ui/react';
import { useNavigate, useLocation } from 'react-router-dom';
import FileLibrary from './FileLibrary';
import WeblinkLibrary from './WeblinkLibrary';

const MyLibrary = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { isOpen: isLibraryOpen, onOpen, onClose } = useDisclosure();

  const isLibraryTab = () => {
    return location.pathname === '/my-library' || location.pathname.startsWith('/my-library/folder');
  }

  return (
    <Box
      height="100vh"
      paddingLeft={"24px"}
      backgroundColor={"#F6FAFF"}
    >
      <Box
        backgroundColor={"white"}
        minH={"100%"}
        h={"100%"}
        borderTopLeftRadius={"8px"}
        paddingY={"25px"}
        paddingLeft={"24px"}
      >
        {/* Header */}
        <Box justifyContent={'space-between'} alignItems={'center'}>
          <HStack>
            <Button 
              height={"40px"}
              bgColor={isLibraryTab() ? '#FFFFFF' : 'transparent'}
              // borderTop={isLibraryTab() ? '0px solid #E2E8F0': "0px solid transparent"}
              // borderX={isLibraryTab() ? '0px solid #E2E8F0': "0px solid transparent"}
              borderBottom={isLibraryTab() ? '2px solid #000': "1px solid transparent"}
              borderRadius={0}
              _hover={{
                backgroundColor: isLibraryTab() ? '#FFFFFF' : '#E2E8F0',
              }}
              onClick={() => navigate('/my-library')}
            >
              <Text fontSize="20px" color="#fffff"> Library </Text>
            </Button>
            <Button
              height={"40px"}
              bgColor={location.pathname === '/my-library/weblinks' ? '#FFFFFF' : 'transparent'}
              // borderTop={location.pathname === '/my-library/weblinks' ? '0px solid #E2E8F0': "0px solid transparent"}
              // borderX={location.pathname === '/my-library/weblinks' ? '0px solid #E2E8F0': "0px solid transparent"}
              borderBottom={location.pathname === '/my-library/weblinks' ? '2px solid #000': "1px solid transparent"}
              borderRadius={0}
              onClick={() => navigate('/my-library/weblinks')}
              _hover={{
                backgroundColor: location.pathname === '/my-library/weblinks' ? '#FFFFFF' : '#E2E8F0',
              }}
            >
              <Text fontSize="20px" color="#fffff"> Weblinks </Text>
            </Button>
          </HStack>
          <Box width="100%" borderBottom="1px solid #E2E8F0" mb={4}></Box>
        </Box>
            {
              location.pathname === '/my-library/weblinks' && <WeblinkLibrary onOpen={onOpen} isLibraryOpen={isLibraryOpen} onClose={onClose} />
            }
            {
              location.pathname === '/my-library' && 
                <FileLibrary 
                  isLibraryOpen={isLibraryOpen} 
                  onClose={onClose}
                  onOpen={onOpen}
                />
            }
            {
              location.pathname.startsWith('/my-library/folder') && 
              <FileLibrary 
                isLibraryOpen={isLibraryOpen} 
                onClose={onClose}
                onOpen={onOpen}
              />
            }
      </Box>
    </Box>
  );
};

export default MyLibrary;
